import { z } from "zod";
import { UuidSchema } from "./common.js";
/**
 * Permissions fines du panel admin web.
 *
 * `web_accounts.is_admin` donne l'acces au panel, puis cette liste decide ce que
 * chaque admin peut consulter ou modifier. Le compte proprietaire garde tout.
 */
export const SITE_ADMIN_PERMISSION_KEYS = [
    "admin.players",
    "admin.player_actions",
    "admin.moderation",
    "admin.ranks",
    "admin.progression",
    "admin.economy",
    "admin.inventory",
    "admin.give",
    "admin.battlepass",
    "admin.npcs",
    "admin.dungeons",
    "admin.config",
    "admin.deploy",
    "admin.content",
    "admin.community",
    "admin.broadcast",
    "admin.performance",
    "admin.logs",
    "admin.map",
    "admin.settings",
    "admin.shop",
    "admin.wipe",
    "admin.admins",
];
export const SiteAdminPermissionKeySchema = z.enum(SITE_ADMIN_PERMISSION_KEYS);
export const SITE_ADMIN_PERMISSION_DEFS = [
    {
        key: "admin.players",
        label: "Joueurs",
        description: "Voir la liste, les profils, les statistiques et les snapshots joueur.",
    },
    {
        key: "admin.player_actions",
        label: "Actions joueur",
        description: "Soigner, nourrir, teleporter, changer le mode de jeu ou gerer le vol.",
    },
    {
        key: "admin.moderation",
        label: "Moderation",
        description: "Kick, ban, mute, warn, freeze, vanish et consulter les sanctions.",
    },
    {
        key: "admin.ranks",
        label: "Grades et rangs",
        description: "Changer les grades payants, rangs gratuits et permissions temporaires.",
    },
    {
        key: "admin.progression",
        label: "Progression",
        description: "Corriger niveaux, XP, metiers et talents.",
    },
    {
        key: "admin.economy",
        label: "Economie",
        description: "Modifier les pieces, les tokens et lancer les resets economie autorises.",
    },
    {
        key: "admin.inventory",
        label: "Inventaire",
        description: "Voir et modifier les inventaires, enderchests et equipements.",
    },
    {
        key: "admin.give",
        label: "Regive",
        description: "Donner des objets vanilla, custom, craft, loot, livres ou kits.",
    },
    {
        key: "admin.battlepass",
        label: "BattlePass",
        description: "Gerer l'acces premium et le suivi BattlePass des joueurs.",
    },
    {
        key: "admin.npcs",
        label: "PNJ",
        description: "Voir, placer, teleporter et synchroniser les PNJ du serveur.",
    },
    {
        key: "admin.dungeons",
        label: "Donjons",
        description: "Gerer les schematics et outils d'administration des donjons.",
    },
    {
        key: "admin.config",
        label: "Configs plugins",
        description: "Lire et modifier les configurations des plugins depuis le site.",
    },
    {
        key: "admin.deploy",
        label: "Deploiement",
        description: "Valider, envoyer et appliquer les packages de deploiement.",
    },
    {
        key: "admin.content",
        label: "Contenu site",
        description: "Publier et modifier les contenus, guides, wiki et pages du site.",
    },
    {
        key: "admin.community",
        label: "Communaute",
        description: "Gerer forum, signalements, suggestions et moderation communautaire.",
    },
    {
        key: "admin.broadcast",
        label: "Serveur",
        description: "Broadcast, messages prives, save-all, reload et operations serveur.",
    },
    {
        key: "admin.performance",
        label: "Performance",
        description: "Consulter les TPS, alertes, garde-fous et diagnostics serveur.",
    },
    {
        key: "admin.logs",
        label: "Journaux",
        description: "Consulter l'audit admin, les logs et l'historique des actions.",
    },
    {
        key: "admin.map",
        label: "Carte",
        description: "Modifier les points d'interet, mondes et donnees admin de la map.",
    },
    {
        key: "admin.settings",
        label: "Reglages site",
        description: "Modifier les reglages globaux du site et des modules publics.",
    },
    {
        key: "admin.shop",
        label: "Boutique",
        description: "Gerer la boutique, les offres, les prix et les achats.",
    },
    {
        key: "admin.wipe",
        label: "Wipe et reset",
        description: "Voir les outils de reset. Les actions destructives restent reservees au proprietaire.",
    },
    {
        key: "admin.admins",
        label: "Administrateurs",
        description: "Promouvoir des admins site et modifier les permissions par personne.",
    },
];
export const SiteAdminPermissionSchema = z.object({
    key: SiteAdminPermissionKeySchema,
    label: z.string(),
    description: z.string(),
    enabled: z.boolean(),
});
export const SiteAdminAccessSchema = z.object({
    accountId: z.number().int().nonnegative().nullable(),
    exists: z.boolean(),
    isAdmin: z.boolean(),
    owner: z.boolean(),
    permissions: z.array(SiteAdminPermissionSchema),
});
export const SetSiteAdminReqSchema = z.object({
    uuid: UuidSchema,
    admin: z.boolean(),
});
export const SetSiteAdminPermissionReqSchema = z.object({
    uuid: UuidSchema,
    permission: SiteAdminPermissionKeySchema,
    enabled: z.boolean(),
});
//# sourceMappingURL=adminPermissions.js.map